import React from "react";


function ImageWithMagnifier({
    src,
    magnifierHeight = 100,
    magnifieWidth = 100,
    zoomLevel = 2,
    className
}) {
    const [[x, y], setXY] = React.useState([0, 0]);
    const [[imgWidth, imgHeight], setSize] = React.useState([0, 0]);
    const [showMagnifier, setShowMagnifier] = React.useState(false);
    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                cursor: "none"
            }}
            className={className}
        >
            <img
                src={src}
                width="100%"
                onMouseEnter={(e) => {
                    const elem = e.currentTarget;
                    const { width, height } = elem.getBoundingClientRect();
                    setSize([width, height]);
                    setShowMagnifier(true);
                }}
                onMouseMove={(e) => {
                    const elem = e.currentTarget;
                    const { top, left } = elem.getBoundingClientRect();
                    const x_ = e.pageX - left - window.pageXOffset;
                    const y_ = e.pageY - top - window.pageYOffset;
                    setXY([x_, y_]);
                }}
                onMouseLeave={() => {
                    setShowMagnifier(false);
                }}
                alt="img"
            />

            <div
                style={{
                    display: showMagnifier ? "" : "none",
                    position: "absolute",
                    pointerEvents: "none",
                    height: `${magnifierHeight}px`,
                    width: `${magnifieWidth}px`,
                    top: `${y - magnifierHeight / 2}px`,
                    left: `${x - magnifieWidth / 2}px`,
                    opacity: "1",
                    backgroundColor: "white",
                    backgroundImage: `url('${src}')`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
                    backgroundPositionX: `${-x * zoomLevel + magnifieWidth / 2}px`,
                    backgroundPositionY: `${-y * zoomLevel + magnifierHeight / 2}px`,
                    boxShadow: "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em"
                }}
            />
        </div>
    );
}

export default ImageWithMagnifier;